import { useState, useEffect, useRef } from 'react';
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';

// ╔════════════════════════════════════════════════════════════════════════════╗
// ║                        🖼️ 사진 교체 가이드                                  ║
// ║  아래 URL 부분만 새 사진 주소로 바꾸시면 됩니다                              ║
// ║  예시: 'https://example.com/my-photo.jpg'                                  ║
// ╚════════════════════════════════════════════════════════════════════════════╝

const GALLERY_IMAGES = {
  // ┌──────────────────────────────────────────────────────────────────────────┐
  // │                              1관 사진 (8장)                               │
  // └──────────────────────────────────────────────────────────────────────────┘
  building1: [
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/148be16a4d4fc6178de836878a7e656e.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/e117e3ce66a7c0538a27c28bf4f69abe.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/4b394d1810b399569af99063ce933d93.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/713b4faaba07799a871586d7225e29a2.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/f7bf8f42af66478a6727880a76628502.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/b5ed9d98314dd290b44c8daaf06f7587.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/577df766ddb7a350743ca1b4fc28fe64.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/15b32b39f1dc89c07da78e52d9a44072.png',
  ],

  // ┌──────────────────────────────────────────────────────────────────────────┐
  // │                              2관 사진 (8장)                               │
  // └──────────────────────────────────────────────────────────────────────────┘
  building2: [
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/4f0f765a4cfd7de2d26629d0a5f3c648.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/62d17f3a0fa9324df193fb73f162facf.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/ffb2a3934363d3fe3a8c36c7ed3bcbe5.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/107372793f70d0e545b0228206738b1e.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/aee9b586dd1bca7c715022e446a96767.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/3121a7dafd06095a4a3223167fdc713a.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/5faf54df7539c087923e310ef4177931.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/7af9ac52d2ca253d4dd92b0461f96f8c.png',
  ],

  // ┌──────────────────────────────────────────────────────────────────────────┐
  // │                              3관 사진 (8장)                               │
  // └──────────────────────────────────────────────────────────────────────────┘
  building3: [
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/e6418fa933c97eecd9bf3cf46de1fffb.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/095d90cf7fe0c557644f373b5b2801fe.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/28a246ddb469a2f73ab4cb1dc5012b81.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/3574db0322ee0fc3ccf8f15bfa7643f1.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/32e8af71d2aabe9458edf4fdd05f0a32.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/408e082b782b8246d71f15f2faedfcc9.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/ce5ba07cf56e73dcb5fa16f598029050.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/e7a69d45de13ae6cd3971c3ae92fa3bd.png',
  ],

  // ┌──────────────────────────────────────────────────────────────────────────┐
  // │                          스터디카페 사진 (8장)                             │
  // └──────────────────────────────────────────────────────────────────────────┘
  studyCafe: [
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/c803065523001fe03540b0d9fea6d36b.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/fbbea5be892a7730038ede1d9df5eb3c.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/feb24979152d992cce5356a81fe144c1.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/73906a6a74acfdc7ea6401d32b41918c.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/599aeb466a0507494e088927c1e57f8d.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/f342cb4325747494dabb587daa3e2f4c.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/4650fe3a8d2206b5b516c99a772f6ad6.png',
    'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/0c22742b7fb846e4c61892ff9ab1f3bb.png',
  ],
};

// 탭 정보
const TABS = [
  { id: 'building1', name: '1관', icon: 'ri-building-line' },
  { id: 'building2', name: '2관', icon: 'ri-building-2-line' },
  { id: 'building3', name: '3관', icon: 'ri-building-3-line' },
  { id: 'studyCafe', name: '스터디카페', icon: 'ri-book-read-line' },
];

export default function JihangCampusPage() {
  const [activeTab, setActiveTab] = useState('building1');
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [isMobile, setIsMobile] = useState(false);
  const [showFeeModal, setShowFeeModal] = useState(false);
  const [feeFormStatus, setFeeFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const tabRefs = useRef<{ [key: string]: HTMLButtonElement | null }>({});

  const currentImages = GALLERY_IMAGES[activeTab as keyof typeof GALLERY_IMAGES];

  // Set page title and meta tags
  useEffect(() => {
    document.title = '미래인재학원 지행캠퍼스 - 동두천 지행 입시학원';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '미래인재학원 지행캠퍼스를 소개합니다. 동두천 지행에 위치한 쾌적한 학습 공간과 체계적인 교육 시스템을 제공합니다.');
    }
    
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', '미래인재학원 지행캠퍼스 - 동두천 지행 입시학원');
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', '미래인재학원 지행캠퍼스를 소개합니다. 동두천 지행에 위치한 쾌적한 학습 공간과 체계적인 교육 시스템을 제공합니다.');
    }
  }, []);

  // LocalBusiness Schema
  useEffect(() => {
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'EducationalOrganization',
      '@id': 'https://miraeinjaehakwon.com/campus/jihang',
      name: '미래인재학원 지행캠퍼스',
      description: '동두천 지행에 위치한 미래인재학원 지행캠퍼스. 중등·고등 수학, 영어, 국어, 과학 입시 전문 학원으로 최신 시설과 체계적인 교육 시스템을 제공합니다.',
      url: 'https://miraeinjaehakwon.com/campus/jihang',
      telephone: '010-5647-1320',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '지행로 50, 성지에스엔비타워 4,5,6층',
        addressLocality: '동두천시',
        addressRegion: '경기도',
        postalCode: '11326',
        addressCountry: 'KR',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 37.9020,
        longitude: 127.0560,
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '13:00',
          closes: '22:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: 'Saturday',
          opens: '10:00',
          closes: '18:00',
        },
      ],
      parentOrganization: {
        '@type': 'EducationalOrganization',
        name: '미래인재학원',
        url: 'https://miraeinjaehakwon.com',
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: '교육 과정',
        itemListElement: [
          { '@type': 'Offer', itemOffered: { '@type': 'Course', name: '중등·고등 수학' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Course', name: '중등·고등 영어' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Course', name: '중등·고등 국어' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Course', name: '중등·고등 과학' } },
        ],
      },
      image: GALLERY_IMAGES.building1[0],
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    script.id = 'jihang-local-business-schema';
    document.head.appendChild(script);

    return () => {
      const existing = document.getElementById('jihang-local-business-schema');
      if (existing) existing.remove();
    };
  }, []);

  // 모바일 감지
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // 이미지 클릭 핸들러
  const handleImageClick = (image: string, index: number) => {
    setSelectedImage(image);
    setSelectedIndex(index);
  };

  // 이전 이미지
  const handlePrev = (e: React.MouseEvent) => {
    e.stopPropagation();
    const newIndex = selectedIndex === 0 ? currentImages.length - 1 : selectedIndex - 1;
    setSelectedIndex(newIndex);
    setSelectedImage(currentImages[newIndex]);
  };

  // 다음 이미지
  const handleNext = (e: React.MouseEvent) => {
    e.stopPropagation();
    const newIndex = selectedIndex === currentImages.length - 1 ? 0 : selectedIndex + 1;
    setSelectedIndex(newIndex);
    setSelectedImage(currentImages[newIndex]);
  };

  // 터치 스와이프 핸들러
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const [touchEnd, setTouchEnd] = useState<number | null>(null);

  const minSwipeDistance = 50;

  const onTouchStart = (e: React.TouchEvent) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    
    if (isLeftSwipe) {
      const newIndex = selectedIndex === currentImages.length - 1 ? 0 : selectedIndex + 1;
      setSelectedIndex(newIndex);
      setSelectedImage(currentImages[newIndex]);
    }
    if (isRightSwipe) {
      const newIndex = selectedIndex === 0 ? currentImages.length - 1 : selectedIndex - 1;
      setSelectedIndex(newIndex);
      setSelectedImage(currentImages[newIndex]);
    }
  };

  // 탭 클릭 시 스크롤 처리
  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
    
    // 모바일에서만 스크롤 처리
    if (window.innerWidth < 768 && tabRefs.current[tabId]) {
      tabRefs.current[tabId]?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  };

  const handleFeeSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFeeFormStatus('submitting');
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    const textarea = form.querySelector('textarea');
    if (textarea && textarea.value.length > 500) {
      alert('문의 내용은 500자 이내로 작성해주세요.');
      setFeeFormStatus('idle');
      return;
    }

    try {
      const urlEncoded = new URLSearchParams();
      formData.forEach((value, key) => {
        urlEncoded.append(key, value.toString());
      });
      
      const res = await fetch('https://readdy.ai/api/form/d6a3p8dt1k61917cmhng', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: urlEncoded.toString(),
      });
      
      if (res.ok) {
        setFeeFormStatus('success');
        form.reset();
        setTimeout(() => {
          setShowFeeModal(false);
          setFeeFormStatus('idle');
        }, 2000);
      } else {
        setFeeFormStatus('error');
      }
    } catch {
      setFeeFormStatus('error');
    }
  };

  return (
    <div className="min-h-screen bg-black">
      <Navigation currentPage="campus" />

      {/* 히어로 섹션 */}
      <section className="pt-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-yellow-400/10 via-transparent to-transparent"></div>
        <div className="absolute top-0 right-0 w-96 h-96 bg-yellow-400/5 rounded-full blur-3xl"></div>
        
        <div className="max-w-6xl mx-auto px-4 py-16 relative">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
            {/* 타이틀 영역 */}
            <div>
              <h1 className="text-4xl md:text-5xl font-black text-white mb-3">
                미래인재학원 <br /><span className="text-yellow-400">지행캠퍼스</span>
              </h1>
            </div>

            {/* 연락처 카드 */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="https://map.naver.com/p/search/%EB%AF%B8%EB%9E%98%EC%9D%B8%EC%9E%AC%ED%95%99%EC%9B%90/place/1862479660?c=15.08,0,0,0,dh&placePath=/home?from=map&fromPanelNum=2&timestamp=202602171844&locale=ko&svcName=map_pcv5&searchText=%EB%AF%B8%EB%9E%98%EC%9D%B8%EC%9E%AC%ED%95%99%EC%9B%90"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 px-6 py-4 bg-neutral-700 border border-neutral-600 rounded-2xl hover:bg-neutral-600 hover:border-yellow-400 transition-all duration-200 cursor-pointer group"
              >
                <div className="w-12 h-12 bg-yellow-400 rounded-xl flex items-center justify-center group-hover:bg-yellow-300 transition-colors">
                  <i className="ri-map-pin-line text-xl text-black"></i>
                </div>
                <div>
                  <p className="text-neutral-300 text-xs font-medium mb-1">주소</p>
                  <p className="text-white font-semibold text-sm">경기도 동두천시 지행로 50</p>
                  <p className="text-neutral-200 text-sm">성지에스엔비타워 4,5,6층</p>
                </div>
              </a>
              
              <a 
                href="tel:010-5647-1320"
                className="flex items-center gap-4 px-6 py-4 bg-neutral-700 border border-neutral-600 rounded-2xl hover:bg-neutral-600 hover:border-yellow-400 transition-all duration-200 cursor-pointer group"
              >
                <div className="w-12 h-12 bg-yellow-400 rounded-xl flex items-center justify-center group-hover:bg-yellow-300 transition-colors">
                  <i className="ri-phone-line text-xl text-black"></i>
                </div>
                <div>
                  <p className="text-neutral-300 text-xs font-medium mb-1">전화 상담</p>
                  <p className="text-white font-bold text-lg">010-5647-1320</p>
                </div>
              </a>

              <a
                href="https://blog.naver.com/eliteoffuture/224136802942"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 px-6 py-4 bg-neutral-700 border border-neutral-600 rounded-2xl hover:bg-neutral-600 hover:border-yellow-400 transition-all duration-200 cursor-pointer group"
              >
                <div className="w-12 h-12 bg-yellow-400 rounded-xl flex items-center justify-center group-hover:bg-yellow-300 transition-colors">
                  <i className="ri-bill-line text-xl text-black"></i>
                </div>
                <div>
                  <p className="text-neutral-300 text-xs font-medium mb-1">수강료</p>
                  <p className="text-white font-semibold text-sm">수강료 안내 보기</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 탭 네비게이션 */}
      <section className="sticky top-16 z-20 bg-black/95 backdrop-blur-md border-y border-neutral-800">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center gap-2 py-4 md:justify-start overflow-x-auto scroll-smooth snap-x snap-mandatory md:snap-none md:overflow-visible [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                ref={(el) => (tabRefs.current[tab.id] = el)}
                onClick={() => handleTabClick(tab.id)}
                className={`flex-shrink-0 snap-center flex items-center gap-1.5 md:gap-2 px-4 md:px-6 py-2.5 md:py-3 rounded-full font-bold text-xs md:text-sm transition-all cursor-pointer whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'bg-yellow-400 text-black shadow-lg shadow-yellow-400/20'
                    : 'bg-neutral-700 text-neutral-300 hover:bg-neutral-600 hover:text-white border border-neutral-600'
                }`}
              >
                <i className={`${tab.icon} text-base md:text-lg`}></i>
                {tab.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* 사진 갤러리 섹션 */}
      <section className="py-16 px-4 bg-black">
        <div className="max-w-6xl mx-auto">
          {/* 현재 탭 헤더 */}
          <div className="flex items-center justify-between mb-10">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 bg-yellow-400 rounded-2xl flex items-center justify-center">
                <i className={`${TABS.find(t => t.id === activeTab)?.icon} text-2xl text-black`}></i>
              </div>
              <div>
                <div className="text-2xl font-bold text-white">
                  {TABS.find(t => t.id === activeTab)?.name}
                </div>
                <p className="text-neutral-500 text-sm">시설 안내</p>
              </div>
            </div>
            <div className="hidden md:flex items-center gap-2 text-neutral-500 text-sm">
              <i className="ri-image-line"></i>
              <span>사진을 클릭하면 크게 볼 수 있습니다</span>
            </div>
          </div>

          {/* 사진 그리드 */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {currentImages.map((image, index) => (
              <div 
                key={`${activeTab}-${index}`}
                onClick={() => handleImageClick(image, index)}
                className="group relative aspect-[3/2] rounded-2xl overflow-hidden bg-neutral-900 cursor-pointer border-2 border-transparent hover:border-yellow-400/50 transition-all duration-300"
              >
                <img
                  src={image}
                  alt={`${TABS.find(t => t.id === activeTab)?.name} 시설 ${index + 1}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 이미지 확대 모달 */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
          onTouchStart={isMobile ? onTouchStart : undefined}
          onTouchMove={isMobile ? onTouchMove : undefined}
          onTouchEnd={isMobile ? onTouchEnd : undefined}
        >
          {/* 닫기 버튼 */}
          <button 
            className="absolute top-6 right-6 w-14 h-14 bg-yellow-400 rounded-full flex items-center justify-center text-black hover:bg-yellow-300 transition-colors cursor-pointer shadow-lg shadow-yellow-400/20 z-10"
            onClick={() => setSelectedImage(null)}
          >
            <i className="ri-close-line text-2xl"></i>
          </button>

          {/* 모바일: 슬라이드 인디케이터 */}
          {isMobile && (
            <>
              {/* 상단 카운터 */}
              <div className="absolute top-6 left-6 px-4 py-2 bg-yellow-400 rounded-full z-10">
                <span className="text-black font-bold text-sm">{selectedIndex + 1} / {currentImages.length}</span>
              </div>
              
              {/* 하단 스와이프 안내 */}
              <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2 text-neutral-400 text-sm z-10">
                <i className="ri-arrow-left-right-line"></i>
                <span>좌우로 밀어서 넘기기</span>
              </div>

              {/* 하단 도트 인디케이터 */}
              <div className="absolute bottom-16 left-1/2 -translate-x-1/2 flex items-center gap-2 z-10">
                {currentImages.map((_, index) => (
                  <div 
                    key={index}
                    className={`w-2 h-2 rounded-full transition-all ${
                      index === selectedIndex ? 'bg-yellow-400 w-6' : 'bg-neutral-600'
                    }`}
                  />
                ))}
              </div>
            </>
          )}

          {/* PC: 좌우 화살표 버튼 */}
          {!isMobile && (
            <>
              <button
                onClick={handlePrev}
                className="absolute left-6 top-1/2 -translate-y-1/2 w-14 h-14 bg-neutral-800 hover:bg-yellow-400 rounded-full flex items-center justify-center text-white hover:text-black transition-all cursor-pointer"
              >
                <i className="ri-arrow-left-s-line text-2xl"></i>
              </button>
              <button
                onClick={handleNext}
                className="absolute right-6 top-1/2 -translate-y-1/2 w-14 h-14 bg-neutral-800 hover:bg-yellow-400 rounded-full flex items-center justify-center text-white hover:text-black transition-all cursor-pointer"
              >
                <i className="ri-arrow-right-s-line text-2xl"></i>
              </button>
              
              {/* PC 카운터 */}
              <div className="absolute bottom-6 left-1/2 -translate-x-1/2 px-4 py-2 bg-neutral-800 rounded-full">
                <span className="text-white font-medium text-sm">{selectedIndex + 1} / {currentImages.length}</span>
              </div>
            </>
          )}

          {/* 이미지 */}
          <div className="relative max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedImage}
              alt="확대 이미지"
              className="w-full max-h-[80vh] object-contain rounded-2xl"
            />
          </div>
        </div>
      )}

      {/* 수강료 문의 모달 */}
      {showFeeModal && (
        <div 
          className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => { setShowFeeModal(false); setFeeFormStatus('idle'); }}
        >
          <div 
            className="bg-neutral-900 border border-neutral-800 rounded-3xl w-full max-w-md p-8 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => { setShowFeeModal(false); setFeeFormStatus('idle'); }}
              className="absolute top-4 right-4 w-10 h-10 bg-neutral-800 hover:bg-neutral-700 rounded-full flex items-center justify-center text-neutral-400 hover:text-white transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-xl"></i>
            </button>

            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-yellow-400 rounded-xl flex items-center justify-center">
                <i className="ri-money-won-circle-line text-2xl text-black"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">수강료 문의</h3>
                <p className="text-neutral-500 text-sm">지행캠퍼스</p>
              </div>
            </div>

            {feeFormStatus === 'success' ? (
              <div className="text-center py-10">
                <div className="w-16 h-16 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-check-line text-3xl text-black"></i>
                </div>
                <p className="text-white font-bold text-lg mb-2">문의가 접수되었습니다!</p>
                <p className="text-neutral-400 text-sm">빠른 시일 내에 연락드리겠습니다.</p>
              </div>
            ) : (
              <form 
                id="jihang-fee-form"
                data-readdy-form
                onSubmit={handleFeeSubmit}
                className="space-y-4"
              >
                <div>
                  <label className="block text-neutral-400 text-sm mb-1.5">학생 이름 <span className="text-yellow-400">*</span></label>
                  <input
                    type="text"
                    name="student_name"
                    required
                    placeholder="학생 이름을 입력해주세요"
                    className="w-full px-4 py-3 bg-neutral-800 border border-neutral-700 rounded-xl text-white text-sm placeholder-neutral-500 focus:outline-none focus:border-yellow-400 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-neutral-400 text-sm mb-1.5">연락처 <span className="text-yellow-400">*</span></label>
                  <input
                    type="tel"
                    name="phone"
                    required
                    placeholder="010-0000-0000"
                    className="w-full px-4 py-3 bg-neutral-800 border border-neutral-700 rounded-xl text-white text-sm placeholder-neutral-500 focus:outline-none focus:border-yellow-400 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-neutral-400 text-sm mb-1.5">학년 <span className="text-yellow-400">*</span></label>
                  <select
                    name="grade"
                    required
                    className="w-full px-4 py-3 bg-neutral-800 border border-neutral-700 rounded-xl text-white text-sm focus:outline-none focus:border-yellow-400 transition-colors cursor-pointer"
                  >
                    <option value="">학년을 선택해주세요</option>
                    <option value="초등 1학년">초등 1학년</option>
                    <option value="초등 2학년">초등 2학년</option>
                    <option value="초등 3학년">초등 3학년</option>
                    <option value="초등 4학년">초등 4학년</option>
                    <option value="초등 5학년">초등 5학년</option>
                    <option value="초등 6학년">초등 6학년</option>
                    <option value="중등 1학년">중등 1학년</option>
                    <option value="중등 2학년">중등 2학년</option>
                    <option value="중등 3학년">중등 3학년</option>
                    <option value="고등 1학년">고등 1학년</option>
                    <option value="고등 2학년">고등 2학년</option>
                    <option value="고등 3학년">고등 3학년</option>
                  </select>
                </div>
                <div>
                  <label className="block text-neutral-400 text-sm mb-1.5">문의 내용</label>
                  <textarea
                    name="message"
                    rows={3}
                    maxLength={500}
                    placeholder="궁금한 과목이나 수업 관련 문의사항을 적어주세요 (500자 이내)"
                    className="w-full px-4 py-3 bg-neutral-800 border border-neutral-700 rounded-xl text-white text-sm placeholder-neutral-500 focus:outline-none focus:border-yellow-400 transition-colors resize-none"
                  ></textarea>
                </div>

                {feeFormStatus === 'error' && (
                  <p className="text-red-400 text-sm">전송에 실패했습니다. 다시 시도해주세요.</p>
                )}

                <button
                  type="submit"
                  disabled={feeFormStatus === 'submitting'}
                  className="w-full py-3.5 bg-yellow-400 hover:bg-yellow-300 text-black font-bold rounded-xl transition-colors cursor-pointer disabled:opacity-50 whitespace-nowrap"
                >
                  {feeFormStatus === 'submitting' ? '전송 중...' : '수강료 문의하기'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}

      {/* Footer */}
      <Footer />
    </div>
  );
}
